<template>
  <div class="main-content">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <cargo-button-group-slider>
          <div>
            <el-button no="Add2" type="primary" :disabled="readonly" @click="addBtnClickHandler">{{ $t('SeaExport.Add2') }}</el-button>
            <el-button no="Delete" type="danger" :disabled="readonly" @click="delBtnClickHandler">{{ $t('SeaExport.Delete') }}</el-button>
            <el-button no="PriceCalculation" type="primary" :disabled="readonly" @click="fentanBtnClickHandler">{{ $t('SeaExport.PriceCalculation') }}</el-button>
            <el-button no="TemplateDownload" type="primary" @click="downTemplateBtn_clickHandler">{{ $t('SeaExport.TemplateDownload') }}</el-button>
            <el-upload
              :disabled="readonly"
              no="ExcelImport"
              :action="URL.seaExport.poItemsImportExcel"
              :headers="{sessionId:context.user.sessionId}"
              :data="{ jobUuid: job.uuid, jobNo: job.jobNo }"
              :show-file-list="false"
              accept=".xls, .xlsx"
              :before-upload="beforeUpload"
              :on-success="uploadSuccess"
              style="display: inline-block;margin-left: 5px;"
            >
              <el-button type="primary" :disabled="readonly">{{ $t('SeaExport.ExcelImport') }}</el-button>
            </el-upload>
            <el-button no="ExcelExport" type="primary" @click="exportBtnClickHandler">{{ $t('SeaExport.ExcelExport') }}</el-button>
            <el-button no="print" type="success" @click="onBatchPrint">{{ $t('SeaExport.print') }}</el-button>
          </div>
        </cargo-button-group-slider>
      </div>
    </div>
    <div class="section" style="flex: 1;">
      <cargo-ag-grid
        config-module="210002"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="poItems"
        style="height: 100%;"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import { isNumber } from '@/utils/validate'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { PoItems } from '@/class/model/booking/PoItems'
import URL from '@/api/urlTranslator'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import { deepCopy } from '@/utils/commonUtil'

export default {
  name: 'AiTabTradeDetail',
  components: { cargoTemplateSelectorDialog, CargoButtonGroupSlider },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    return {
      job: new AirImportJob().fillDefaultValue().getData(),
      poItems: [],
      delPoItemsUuids: [], // 删除的uuid
      templateSelectorDialog: {
        visible: false,
        cxt: new AirImportJob(),
        category: 'AIPOITEMS',
        data: {
          POITEMS_UUID: []
        }
      }
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    columnDefs() {
      const columnDefs = [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('SeaExport.OrderNo'),
          headerTooltip: this.$t('SeaExport.OrderNo'),
          colId: 'orderNo',
          field: 'orderNo',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input'
          }
        }, {
          headerName: 'ACPT',
          headerTooltip: 'ACPT',
          field: 'moduleCode',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input'
          }
        }, {
          headerName: this.$t('SeaExport.CaseNo'),
          headerTooltip: this.$t('SeaExport.CaseNo'),
          field: 'caseNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input'
          }
        }, {
          headerName: this.$t('SeaExport.Item'),
          headerTooltip: this.$t('SeaExport.Item'),
          field: 'itemNo',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input'
          }
        }, {
          headerName: this.$t('SeaExport.Sub'),
          headerTooltip: this.$t('SeaExport.Sub'),
          field: 'subItemNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input'
          }
        }, {
          headerName: 'SUPPLY PARTS NO',
          headerTooltip: 'SUPPLY PARTS NO',
          field: 'supplyPartNo',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input'
          }
        }, {
          headerName: 'ORDER PARTS NO',
          headerTooltip: 'ORDER PARTS NO',
          field: 'orderPartNo',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input'
          }
        }, {
          headerName: 'HS CODE',
          headerTooltip: 'HS CODE',
          field: 'hsCode',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input'
          }
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          headerTooltip: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'chineseCommodity',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        }, {
          headerName: this.$t('SeaExport.Size2'),
          headerTooltip: this.$t('SeaExport.Size2'),
          field: 'itemSpec',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input'
          }
        }, {
          headerName: this.$t('SeaExport.CommodityClassification'),
          headerTooltip: this.$t('SeaExport.CommodityClassification'),
          field: 'customsCommodity',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        }, {
          headerName: this.$t('SeaExport.Qty'),
          headerTooltip: this.$t('SeaExport.Qty'),
          field: 'quantity',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        }, {
          headerName: this.$t('SeaExport.UnitOfMeasurement'),
          headerTooltip: this.$t('SeaExport.UnitOfMeasurement'),
          field: 'measure',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input'
          }
        }, {
          headerName: this.$t('SeaExport.NetWeight'),
          headerTooltip: this.$t('SeaExport.NetWeight'),
          field: 'netWeight',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        }, {
          headerName: 'WEIGHT',
          headerTooltip: 'WEIGHT',
          field: 'grossWeight',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          headerTooltip: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        }, {
          headerName: 'AMOUNT',
          headerTooltip: 'AMOUNT',
          field: 'purchaseAmount',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        }, {
          headerName: 'AMOUNT(RMB)',
          headerTooltip: 'AMOUNT(RMB)',
          field: 'purchaseAmountRMB',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              textConverter: (val, data) => {
                if (data) {
                  return (Math.round(data.purchaseAmount * data.pruchaseExchangeRate)).toFixed(2)
                }
                return ''
              }
            }
          }
        }, {
          headerName: this.$t('SeaExport.CustomsDutyRate'),
          headerTooltip: this.$t('SeaExport.CustomsDutyRate'),
          field: 'purchaseTariffRate',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        }, {
          headerName: this.$t('SeaExport.CustomsDuties'),
          headerTooltip: this.$t('SeaExport.CustomsDuties'),
          field: 'purchaseTariffAmount',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        }, {
          headerName: this.$t('SeaExport.IncrementValueDutyRate'),
          headerTooltip: this.$t('SeaExport.IncrementValueDutyRate'),
          field: 'purchaseValRate',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        }, {
          headerName: this.$t('SeaExport.IncrementValueDuty'),
          headerTooltip: this.$t('SeaExport.IncrementValueDuty'),
          field: 'purchaseValAmount',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        }, {
          headerName: this.$t('SeaExport.ConsumptionDutyRate'),
          headerTooltip: this.$t('SeaExport.ConsumptionDutyRate'),
          field: 'purchaseExciseRate',
          width: 110,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        }, {
          headerName: this.$t('SeaExport.ConsumptionDuty'),
          headerTooltip: this.$t('SeaExport.ConsumptionDuty'),
          field: 'purchaseExciseAmount',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        }, {
          headerName: this.$t('SeaExport.ConsolidatedTax'),
          headerTooltip: this.$t('SeaExport.ConsolidatedTax'),
          field: 'totalRateAmount',
          width: 100,
          cellRenderer: params => {
            const data = params.data
            if (data) {
              return Number(data.purchaseTariffAmount + data.purchaseValAmount + data.purchaseExciseAmount).toFixed(2)
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.Currency'),
          headerTooltip: this.$t('SeaExport.Currency'),
          field: 'purchaseCurrency',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            clearable: false,
            isEdit: this.isEdit,
            tag: 'cargo-advance-select',
            selectType: TYPE_NAMES.basic_data_Currency,
            tagValue: 'code',
            tagName: 'code'
          }
        }, {
          headerName: this.$t('SeaExport.ExchangeRate'),
          headerTooltip: this.$t('SeaExport.ExchangeRate'),
          field: 'pruchaseExchangeRate',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 6))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        }, {
          headerName: this.$t('SeaExport.CargoPrice'),
          headerTooltip: this.$t('SeaExport.CargoPrice'),
          field: 'sellPrice',
          width: 100,
          cellRenderer: params => {
            return params.data ? ColumnUtils.numberColumnLabelFunc(params.data.sellPrice, 2) : 0.00
          },
          cellStyle: () => {
            return { backgroundColor: '#EEEEEE' }
          }
        }, {
          headerName: this.$t('SeaExport.Tax'),
          headerTooltip: this.$t('SeaExport.Tax'),
          field: 'sellValAmount',
          width: 100,
          cellRenderer: params => {
            return params.data ? ColumnUtils.numberColumnLabelFunc(params.data.sellValAmount, 2) : 0.00
          },
          cellStyle: () => {
            return { backgroundColor: '#EEEEEE' }
          }
        }, {
          headerName: this.$t('SeaExport.TaxRate'),
          headerTooltip: this.$t('SeaExport.TaxRate'),
          field: 'sellValRate',
          width: 100,
          cellStyle: () => {
            return { backgroundColor: '#EEEEEE' }
          }
        }
      ]
      return columnDefs
    }
  },
  created() {
    this.URL = URL
    this.gridOptions = {
      rowSelection: 'multiple',
      singleClickEdit: true,
      suppressCellSelection: true,
      context: {
        componentParent: this
      },
      frameworkComponents: { // 添加编辑组件
        CargoAgGridCommonTextareaEditor
      }
    }
    this.gridApi = null
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.job = row
      this.poItems = await new AirImportJob(row).getPoItems()
      if (this.isEdit && this.job.uuid) {
        this.$emit('syncData', { poItems: deepCopy(this.job.poItems) })
      }
    },
    // 新增
    addBtnClickHandler() {
      const item = new PoItems().fillDefaultValue().getData()
      item.purchaseCurrency = 'USD'
      item.jobUuid = this.job.uuid
      if (this.poItems && this.poItems.length > 0) {
        const lastItem = this.poItems[0]
        if (lastItem) {
          item.purchaseCurrency = lastItem.purchaseCurrency
        }
      }
      this.poItems.push(item)
    },
    // 删除
    delBtnClickHandler() {
      const selections = this.gridApi.getSelectedRows()
      if (selections.length > 0) {
        for (const item of selections) {
          if (item.uuid) {
            this.delPoItemsUuids.push(item.uuid)
          }
          const index = this.poItems.findIndex(p => p === item)
          this.poItems.splice(index, 1)
        }
      }
    },
    fentanBtnClickHandler() {
      const amountRMBTotal = this.rmbTotal()
      const receivable = this.getReceivable()
      for (const item of this.poItems) {
        this.calculatePoItemsSell(item, amountRMBTotal, receivable)
      }
      this.$message.info(this.$t('queryJob.SellingPriceCalculationCompleted'))
    },
    rmbTotal() {
      let result = 0
      for (const item of this.poItems) {
        result += Number(Math.round(item.purchaseAmount * item.pruchaseExchangeRate).toFixed(2))
      }
      return result
    },
    getReceivable() {
      if (this.job.charges.length === 0) {
        return 0
      }
      let result = 0
      for (const charge of this.job.charges) {
        if (charge && charge.receivable) {
          result += Number(((charge.excludingTaxAmount + charge.taxAmount) * charge.exchangeRate).toFixed(2))
        }
      }
      return result
    },
    // 分摊
    calculatePoItemsSell(item, totalValue, receivable) {
      item.sellAmount = receivable * item.purchaseAmount * item.pruchaseExchangeRate / totalValue
      item.sellAmount = Number(item.sellAmount.toFixed(2))
      item.sellAmount = isNaN(item.sellAmount) ? 0 : item.sellAmount
      item.sellPrice = item.sellAmount / (1 + item.sellValRate / 100)
      item.sellPrice = Number(item.sellPrice.toFixed(2))
      item.sellPrice = isNaN(item.sellPrice) ? 0 : item.sellPrice
      item.sellValAmount = item.sellPrice * item.sellValRate / 100
      item.sellValAmount = Number(item.sellValAmount.toFixed(2))
      item.sellValAmount = isNaN(item.sellValAmount) ? 0 : item.sellValAmount
    },
    // 下载模板
    downTemplateBtn_clickHandler() {
      const fileName = 'PoItemsImportTemplate.xls'
      const folderName = 'price'
      ExportUtils.downloadTemplateFile(fileName, folderName)
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(response.data)
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    //  excel 导入后逻辑处理
    onImportSucceeded(data) {
      let count = 0
      if (data && data.poItemsList && data.poItemsList.length > 0) {
        if (this.job) {
          count = data.poItemsList.length
          for (const item of data.poItemsList) {
            this.poItems.push(item)
          }
        }
      }
      this.$message.success(this.$t('Message.ImportSuccessful1') + count + this.$t('Message.ImportSuccessful2'))
    },
    // Excel 导出
    exportBtnClickHandler() {
      if (!this.poItems || this.poItems.length <= 0) {
        this.$message.warning(this.$t('Message.NoData')) // 判断列表是否有数据
        return
      }
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.SelectTheData')) // 判断是否选中数据
        return
      }
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      const fileName = '空运进口货物操作明细'
      exportExcel(fileName, rows, allDisplayedColumns)
    },
    // 打印
    onBatchPrint() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.CargoDetailsIsNotSelected'))
        return
      }
      const uids = Array.from(rows, j => j.uuid)
      if (uids.length > 0) {
        this.templateSelectorDialog.cxt = new AirImportJob(this.job)
        this.templateSelectorDialog.data = { 'POITEMS_UUID': uids, 'jobuuid': this.job.uuid }
        this.templateSelectorDialog.visible = true
      }
    },
    getSubmitData() {
      return {
        job: this.job,
        poItems: this.poItems,
        delPoItemsUuids: this.delPoItemsUuids
      }
    }
  }
}
</script>

<style scoped lang="scss">
#app .main-content .section ::v-deep .ag-theme-balham {
  .ag-header-cell:after {
    height: 100%;
    top: unset;
  }
  .ag-cell {
    border:none;
    border-right: 1px solid var(
      --ag-header-column-separator-color,
      hsla(204, 8%, 76%, 0.5)
    );
  }
}
</style>
